import { useMediaQuery, useTheme } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { checkPermission, renderDate } from "../../../utils/app.utils";
import OptionsButtonCustom from "../../../components/option-button/OptionsButtonCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import moment from "moment";
import { alertActive, alertError, alertSuccess } from "../../../components/alert/swal";
import { useNavigate } from "react-router-dom";
// import { RoutePath } from "../../../routes/Routes";
// import { renderStatus } from "../../manage-articles/enum/article.enum";
import SwitchCustom from "../../../components/switch/SwitchCustom";
import { RootState } from "../../../store/store";
import { routeName } from "../../../routes/routeName";
import { useTranslation } from "react-i18next";
import { FormPollApi, poll_list_type } from "../../../api/form-poll/form_poll.api";
import { dateTimeToView } from "../../../utils/date.utils";
import { STATUS_DATA } from "../../../constants/enum";
import { STATUS_ENUM } from "../website-structure/content/enum/content.enum";

export const ManageState = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const navigate = useNavigate();

    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('WEBSITE_STRUCTURE_POLL_VOTE', permission);


    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [search, setSearch] = useState<string>("");
    const [startDate, setStartDate] = useState<string | null>("");
    const [data, setData] = useState<any[]>([]);
    const [endDate, setEndDate] = useState<string | null>("");
    const [banner_type, set_banner_type] = useState<string>("");
    const [poll_type_data, set_poll_type_data] = useState<any[]>([]);
    const [id_poll_type, set_id_poll_type] = useState<number | null>(null);

    const [id_information_source, set_id_information_source] = useState<any>(null);

    const headCell = [
        {
            id: "seq", width: 50, sortable: true, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "form_poll_name", disablePadding: false, width: 200, sortable: false, align: "left", label: t("ชื่อ")
        },
        {
            id: "2", disablePadding: false, width: 100, sortable: false, align: "center", label: t("หมวดหมู่")
        },
        {
            id: "3", disablePadding: false, width: 100, sortable: false, align: "center", label: t("ช่วงวันที่เปิดให้โหวต")
        },
        {
            id: "22", disablePadding: false, width: 80, sortable: false, align: "center", label: t("เผยแพร่")
        },
        {
            id: "3", disablePadding: false, width: 100, sortable: false, align: "center", label: t("ผู้สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "4", disablePadding: false, width: 90, sortable: false, align: "center", label: t("วันที่สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "action", disablePadding: false, align: "left", class: matches && data.length > 0, width: 80, label: ""
        },
    ];


    const handleChangeDateRange = (st_date: string | null, end_date: string | null) => {
        setStartDate(st_date)
        setEndDate(end_date)
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }
    const handleGetPollType = async () => {
        await FormPollApi.dropdownPollType().then((res) => {
            if (res.status < 300) {
                const data_value = res.data?.data || [];
                set_poll_type_data(data_value)
            }
        }).catch((err) => err)
    }


    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            modified_date,
            // modified_by,
            created_date,
            // content_name,
            form_poll_name,
            // status,
            // content_start_date,
            // content_start_time,
            // content_end_date,
            // content_end_time,
            id_form_poll,
            is_public,
            status,
            poll_type,
            form_poll_start,
            form_poll_end,
            created_by,
            modified_by
        } =
            objData;

        const date_poll_range = `${form_poll_start ? dateTimeToView(form_poll_start) : t("ยังไม่มีข้อมูล")} - ${form_poll_end ? dateTimeToView(form_poll_start) : t("ยังไม่มีข้อมูล")}`

        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: form_poll_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: poll_type || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: date_poll_range || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: <div className="flex justify-center items-center">
                        <SwitchCustom
                            checked={is_public ? true : false}
                            onChange={(st) => handleUpdateStatus(id_form_poll, st)}
                        />
                    </div>
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_by ? modified_by : created_by || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : created_date ? dateTimeToView(created_date) : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches,
                    component:
                        <div className="flex justify-center items-center">
                            <span>
                                <OptionsButtonCustom
                                    // enableView
                                    // enableEdit
                                    // enableDelete
                                    enableView={checkPermit.isView}
                                    enableEdit={(status === STATUS_ENUM.DRAFT || !Number(is_public)) && checkPermit.isUpdate}
                                    enableDelete={checkPermit.isDelete}
                                    onDeleteClick={() => handleDeleteContent(id_form_poll)}
                                    onViewClick={() => navigate(routeName.cms_website.poll_vote_view.replace(":id", id_form_poll))}
                                    onEditClick={() => navigate(routeName.cms_website.poll_vote_detail.replace(":id", id_form_poll))}
                                />
                            </span>
                        </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleUpdateStatus = async (id_content: number, is_public: boolean) => {
        await FormPollApi.updateStatus(id_content, {
            is_public
        }).then((res) => {
            if (res.status < 300) {
                handleGetData();
            }
        }).catch((err) => {
            console.log(err)
            alertError(t("อัพเดตสถานะไม่สำเร็จ"))
        })
    }
    const handleDeleteContent = (id_form_poll: number) => {
        alertActive(t("ลบรายการ"), t("ท่านต้องการลบรายการนี้?"), undefined, undefined, async () => {
            dispatch(setLoading());
            await FormPollApi.delete(id_form_poll).then((res) => {
                if (res.status < 300) {
                    handleGetData();
                    alertSuccess(t("ลบรายการ"), t("ลบรายการ เรียบร้อย"))
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("ลบรายการ"), t("ลบรายการ ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }

    const handleGetData = useCallback(async () => {
        let query: poll_list_type = {
            page,
            limit: pageLimit,
            sortBy,
            sortType,
        }
        if (search) query = { ...query, search: search }
        if (id_poll_type) query.id_poll_type = id_poll_type
        if (startDate && endDate) query = {
            ...query,
            end_date: moment(endDate).format("YYYY-MM-DD"),
            start_date: moment(startDate).format("YYYY-MM-DD"),
        }
        dispatch(setLoading());
        await FormPollApi.list(query).then((res) => {
            if (res.status < 300) {
                const data = res?.data?.data?.items || []
                setData(data)
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
            }
        }).catch((err) => console.log(err)).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, sortBy, id_poll_type, sortType, startDate, search, , endDate, banner_type])


    useEffect(() => {
        handleGetPollType();
    }, [])
    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        handleRequestSort,
        sortBy,
        sortType,
        renderData,
        headCell,
        totalItems,
        data,
        setSearch,
        handleChangeDateRange,
        startDate,
        endDate,
        id_information_source,
        set_id_information_source,
        banner_type,
        set_banner_type,
        checkPermit,
        poll_type_data,
        set_id_poll_type,
        id_poll_type
    }
}